// extracted by mini-css-extract-plugin
module.exports = {"container":"KcWelcomeLayer_container__2ZvlM","image":"KcWelcomeLayer_image__3d729","show":"KcWelcomeLayer_show__3FUFa"};